import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../auth/service/auth.service';
import { toCamelCase } from '@shared/utils/string-case-manipulation';
import { User } from '../auth/model/interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthViewGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const projectName =
      route.paramMap.get('project') ?? this.authService.projectId ?? '';
    return from(this.authService.isLoggedIn(projectName)).pipe(
      map((response) => {
        if (response.data) {
          this.authService.user = toCamelCase(response.data) as User;
          return true;
        }
        return this.router.createUrlTree(['/login']);
      }),
      catchError(() => of(this.router.createUrlTree(['/login']))),
    );
  }
}
